import { JwtTokenFn } from "@me8eon/authentication";
import axios, {AxiosResponse} from "axios";

type HitBuilder<Resource> = {
    hitId: string;
    rank: number;
    summary: string;
    resource: Resource
}

export type GraphApiPhone = {
    type: "business" | "mobile";
    number: string;
}

export type OrganizationUser = HitBuilder<{
    "@odata.type": "#microsoft.graph.person";
    id: string;
    displayName: string;
    givenName?: string;
    surname?: string;
    companyName?: string;
    jobTitle?: string;
    department?: string;
    officeLocation?: string;
    additionalOfficeLocation?: string;
    personType: {
        class: "Person";
        subclass: "OrganizationUser";
    };
    userPrincipalName: string;
    imAddress?: string;
    phones?: Array<GraphApiPhone>
}>

type ImplicitContact = HitBuilder<{
    "@odata.type": "#microsoft.graph.person";
    id: string;
    displayName: string;
    personType: {
        class: "Person";
        subclass: "ImplicitContact";
    };
    userPrincipalName: string;
}>

export type GraphApiHits = Array<OrganizationUser | ImplicitContact>;

type HitsContainer = {
    hits?: GraphApiHits
    total: number;
    moreResultsAvailable: boolean;
}

type Value = {
    hitsContainers?: HitsContainer[];
}

export type GraphApiResponse = {
    value: Value[];
    "@odata.context": string;
};

export type ManagerGraphApiResponse = {
    id: string;
    displayName: string;
    manager?: {
        id: string;
        displayName: string;
        mail: string;
        userPrincipalName: string;
        businessPhones?: string[];
        mobilePhone?: string;
    }
}

export type TeamGraphApiResponse = {
    id: string;
    displayName: string;
    mail: string;
    directReports?: {
        id: string;
        displayName: string;
        mail: string;
        userPrincipalName: string;
    }[]
}

export const postGraphApi: (body: any, tokenFn: JwtTokenFn) => Promise<AxiosResponse<GraphApiResponse>> = async (body, tokenFn) => await axios.post("https://graph.microsoft.com/v1.0/search/query", body, {
    headers: {
        Authorization: `Bearer ${await tokenFn()}`,
        "Content-Type": "application/json",
        Accept: "application/json",
    }
});

export const getGraphApi: <T>(
    path: string,
    tokenFn: JwtTokenFn,
    queryParams?: Record<string, any>,
    headers?: Record<string, any>
) => Promise<AxiosResponse<T>> = async (path, tokenFn, queryParams, headers) =>
    await axios.get(`https://graph.microsoft.com/v1.0/${path}`, {
        headers: {
            Authorization: `Bearer ${await tokenFn()}`,
            "Content-Type": "application/json",
            Accept: "application/json",
            ...headers,
        },
        params: queryParams,
    });
